import { useEffect, useState } from 'react';
import Footer from '../../Components-2/Footer';
import Header from '../../Components-2/Header/Header';
import Sidebar1 from '../../Components-2/Sidebar1';
import { useLocation } from 'react-router-dom';
import Bill from './Bill';
import ViewBill from './ViewBill';
import Quotation from './Quotation';
import FutureSalesData from './FutureSalesData';

function FutureInvoice() {
  const location = useLocation();

  // Get user permissions
  const permissions = JSON.parse(localStorage.getItem("Login")) || {};
  const has = (key) => permissions[key] === 1;

  const [selectedInvoice, setSelectedInvoice] = useState(null);

  // Define tabs with permissions
  const tabs = [
    { id: 'Bill', label: 'Generate Invoice', component:
    (
        <Bill
          selectedInvoice={selectedInvoice}
          setSelectedInvoice={setSelectedInvoice}
         
        />
      ), permission: 1 },
    { id: 'ViewBill', label: 'View Invoice', component: 
    (
        <ViewBill
          switchToInvoice={(InvoiceNo) => {
            setSelectedInvoice(InvoiceNo);
            setActiveTab("Bill"); // 🔥 SWITCH TAB
          }}
        />
      ), permission: 1 },
    { id: 'Quotation', label: 'Quotation', component: <Quotation/>, permission: 1 },
    { id: 'Sales', label: 'Gst Data', component: <FutureSalesData/>, permission: 1 },
  ];

  // Filter tabs based on permissions
  const visibleTabs = tabs.filter(tab => tab.permission);

  const [activeTab, setActiveTab] = useState(location?.state?.tab || visibleTabs[0]?.id || null);

  useEffect(() => {
    if (!activeTab && visibleTabs.length > 0) {
      setActiveTab(visibleTabs[0].id);
    }
  }, [visibleTabs, activeTab]);

  return (
    <>
      <Header />
      <Sidebar1 />
      <div id="main-body">
        <div className="container">
          {/* Navigation Tabs */}
          <nav style={{ height: "28px" }}>
            {visibleTabs.map(tab => (
              <label
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
              >
                {tab.label}
              </label>
            ))}

            {/* Slider */}
            <div
              className="slider"
              style={{
                left: `${visibleTabs.findIndex(t => t.id === activeTab) * (100 / visibleTabs.length)}%`,
                width: `${100 / visibleTabs.length}%`,
              }}
            />
          </nav>

          {/* Dynamic Tab Content */}
          <section>
            {visibleTabs.find(t => t.id === activeTab)?.component}
          </section>
        </div>

        <Footer />
      </div>
    </>
  );
}

export default FutureInvoice;
